import { Maybe } from '@csp/csp-common-model';
import { UnbookedVisit } from './UnbookedVisit';

export type UnbookedVisits = {
  /** Whether any visits are configured. There might however be no applicable to book. */
  getTimeboundedVisits: () => UnbookedVisit[];
  getNonTimeboundedVisits: () => UnbookedVisit[];
  getMatchedByUniqueVisitId: (visitId: string) => Maybe<UnbookedVisit>;
  all: UnbookedVisit[];
  hasScheduledVisits: boolean;
};

const timeboundedVisits = (unbookedVisits: UnbookedVisit[]): UnbookedVisit[] =>
  unbookedVisits.filter(visit => visit.timebound);

const nonTimeboundedVisits = (unbookedVisits: UnbookedVisit[]): UnbookedVisit[] =>
  unbookedVisits.filter(visit => !visit.timebound);

const matchByUniqueVisitId = (unbookedVisits: UnbookedVisit[], visitId: string): Maybe<UnbookedVisit> =>
  unbookedVisits.find(visit => visit.uniqueId === visitId);

const empty = (): UnbookedVisits => from([], false);

const from = (unbookedVisits: UnbookedVisit[], hasScheduledVisits: boolean): UnbookedVisits => ({
  // TODO [OFRAZU-28083]: Add utility functions to filter out the different visit variants and types.
  getTimeboundedVisits: () => timeboundedVisits(unbookedVisits),
  getNonTimeboundedVisits: () => nonTimeboundedVisits(unbookedVisits),
  getMatchedByUniqueVisitId: (visitId: string) => matchByUniqueVisitId(unbookedVisits, visitId),
  all: unbookedVisits,
  hasScheduledVisits,
});

export const UnbookedVisits = {
  empty,
  from,
};
